import React from "react";
import { Link } from "react-router-dom";

const solutions = [
  {
    name: "Dispatch Planning",
    path: "/dispatch-planning",
  },
  {
    name: "Contract and Spot Auction",
    path: "/freight-sourcing-and-reverse-auction",
  },
  {
    name: "Indent Automation",
    path: "/indent-automation",
  },
  {
    name: "In-Plant Vehicle Movement and Optimization",
    path: "/in-plant-vehicle-movement-and-optimization",
  },
  {
    name: "Tracking",
    path: "/tracking",
  },
  {
    name: "EXIM (Import/Export)",
    path: "/exim",
  },
  {
    name: "Proof of Delivery",
    path: "/proof-of-delivery",
  },
  {
    name: "Invoicing",
    path: "/invoicing",
  },
  {
    name: "Dashboard and Analytics",
    path: "/dashboard-analytics",
  },
];

const SolutionsDropdown = ({ closeMobileMenu, isMobile }) => {
  // For mobile, simple vertical block, for desktop absolute dropdown box
  if (isMobile) {
    return (
      <div className="pl-4 space-y-2">
        {solutions.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            onClick={closeMobileMenu}
            className="block text-primaryBlue hover:text-blue-700"
          >
            {item.name}
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className="absolute top-full left-0 mt-3 w-[520px] max-w-[calc(100vw-32px)] bg-white/95 backdrop-blur shadow-xl rounded-2xl border border-primaryBlue/10 p-3 text-sm z-50">
      <div className="px-2 pt-1 pb-2">
        <div className="text-[13px] font-semibold text-slate-900">
          Solutions
        </div>
        <div className="mt-0.5 text-[12px] text-slate-600">
          Explore modules built for planning, execution, visibility, and
          finance.
        </div>
      </div>

      <div className="grid grid-cols-2 gap-1">
        {solutions.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            onClick={closeMobileMenu}
            className="group flex items-center justify-between gap-3 rounded-xl px-3 py-2.5 text-primaryBlue hover:bg-primaryBlue/5 transition"
          >
            <span className="font-medium leading-snug text-primaryBlue">
              {item.name}
            </span>
            <span className="text-primaryBlue/60 group-hover:text-primaryBlue transition">
              →
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SolutionsDropdown;
